import store from "@/config/vuex/store";

export default[
    {
        path: "/",
        component: () => import('@/pages/Layout/DashboardLayout'),
        children: [
            {
                path: "/dashboard",
                name: "Dashboard",
                component: () => import('@/pages/Dashboard/Dashboard'),
            }
        ]
    }
]
